import axios from 'axios'
import { ADMIN_URL } from 'shared/app-settings';
const access_token = localStorage.getItem('access_token');
const User_Id = localStorage.getItem('User_Id');

const loginService = {
    rigisterAccount(body) {
        return axios.post(ADMIN_URL + 'user/register', body);
    },

    loginclient(body) {
        return axios.post(ADMIN_URL + 'user/login', body);
    },
    updateUser(body) {
        return axios.post(ADMIN_URL + 'user/update', body);
    },
    refreshToken() {
        return axios.post(ADMIN_URL + 'refreshToken', { userId: User_Id }, {
            headers: {
                Authorization: `${access_token}`
            }
        });

    },
    checkUserStatus(body) {
        return axios.post(ADMIN_URL + 'user/checkUserStatus', body);
    },

    gettruongdhlayapptis(body) {
        return axios.get(ADMIN_URL + 'gettruongdhlayapptis', {
            params: body
        });
    },
}
export { loginService };